import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

function HttpRequestNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-white dark:bg-gray-900 shadow-sm min-w-[180px] transition-shadow ${
      selected ? 'border-amber-500 shadow-amber-100 dark:shadow-amber-900/20' : 'border-gray-200 dark:border-gray-700'
    }`}>
      <Handle type="target" position={Position.Top} className="!bg-amber-500 !w-3 !h-3 !border-2 !border-white dark:!border-gray-900" />
      <div className="flex items-center gap-2 px-4 py-2.5 bg-amber-50 dark:bg-amber-900/20 rounded-t-[10px] border-b border-gray-200 dark:border-gray-700">
        <div className="w-2.5 h-2.5 rounded-full bg-amber-500" />
        <span className="text-xs font-semibold text-amber-700 dark:text-amber-300">HTTP Request</span>
      </div>
      <div className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
        {data.config?.url ? `${(data.config.method || 'POST').toUpperCase()} ${data.config.url.substring(0, 30)}...` : 'Click to configure'}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-amber-500 !w-3 !h-3 !border-2 !border-white dark:!border-gray-900" />
    </div>
  );
}

export default memo(HttpRequestNode);
